import React from 'react';
import Icon from '../../../components/AppIcon';

const CustomerInfoCard = ({ customer, vehicle }) => {
  if (!customer) return null;

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="User" size={20} color="var(--color-primary)" />
        <h3 className="text-base md:text-lg font-semibold text-foreground">
          Información del Cliente
        </h3>
      </div>
      <div className="space-y-4">
        <div>
          <p className="text-xs md:text-sm text-muted-foreground mb-1">Nombre</p>
          <p className="text-sm md:text-base font-medium text-foreground">
            {customer?.name}
          </p>
        </div>

        <div>
          <p className="text-xs md:text-sm text-muted-foreground mb-1">Teléfono</p>
          <div className="flex items-center gap-2">
            <Icon name="Phone" size={16} color="var(--color-muted-foreground)" />
            <p className="text-sm md:text-base font-medium text-foreground">
              {customer?.phone}
            </p>
          </div>
        </div>

        {customer?.email && (
          <div>
            <p className="text-xs md:text-sm text-muted-foreground mb-1">Email</p>
            <div className="flex items-center gap-2">
              <Icon name="Mail" size={16} color="var(--color-muted-foreground)" />
              <p className="text-sm md:text-base font-medium text-foreground break-all">
                {customer?.email}
              </p>
            </div>
          </div>
        )}

        {vehicle && (
          <>
            <div className="pt-4 border-t border-border">
              <div className="flex items-center gap-2 mb-3">
                <Icon name="Car" size={18} color="var(--color-primary)" />
                <h4 className="text-sm md:text-base font-semibold text-foreground">
                  Vehículo
                </h4>
              </div>
            </div>

            <div>
              <p className="text-xs md:text-sm text-muted-foreground mb-1">Marca y Modelo</p>
              <p className="text-sm md:text-base font-medium text-foreground">
                {vehicle?.brand} {vehicle?.model}
              </p>
            </div>

            <div>
              <p className="text-xs md:text-sm text-muted-foreground mb-1">Año</p>
              <p className="text-sm md:text-base font-medium text-foreground">
                {vehicle?.year}
              </p>
            </div>

            <div>
              <p className="text-xs md:text-sm text-muted-foreground mb-1">Placas</p>
              <div className="flex items-center gap-2">
                <div className="px-3 py-1.5 bg-muted rounded-lg">
                  <p className="text-sm md:text-base font-bold text-foreground tracking-wider">
                    {vehicle?.plates}
                  </p>
                </div>
              </div>
            </div>

            {vehicle?.color && (
              <div>
                <p className="text-xs md:text-sm text-muted-foreground mb-1">Color</p>
                <p className="text-sm md:text-base font-medium text-foreground">
                  {vehicle?.color}
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CustomerInfoCard;